import {Observable} from "rxjs/Observable";
import 'rxjs/add/operator/mergeAll';
import 'rxjs/add/operator/combineAll';

export class NestedItemsResolver {

    public static buildObservables(parent$ : Observable<any>, property : string, apiService : any, propertyId : string = 'id') {
        const pArr$ : any = parent$.map((items : any[]) => items.map( (item) => {
                    if (item[property] && item[property].length > 0) {
                        return item[property];
                    }
                    return [{}];
                } ))
            .map((nestedArrayArray : any[][]) => nestedArrayArray.reduce( (a, b ) => a.concat(b), []) )
            .map((nestedArray : any[]) => nestedArray.map( value => value[propertyId]))
            .map((propertyIds : any[]) => propertyIds.filter((id, index , array) => array.indexOf(id) === index))
            .map((ids : any[]) => ids.map( (id : any) => {
                    if (id) {
                        return apiService.findById(id);
                    }
                    return Observable.of(null);
                } )
            ).mergeAll();

        return pArr$.combineAll();
    }

    public static buildObservablesFromItem(parent$ : Observable<any>, property : string, apiService : any, propertyId : string = 'id') {
        const pArr$ : any = parent$.map((item) => {
                if (item[property] && item[property].length > 0) {
                    return item[property];
                }
                return [{}];
            } )
            .map((nestedArrayArray : any[][]) => nestedArrayArray.reduce( (a, b ) => a.concat(b), []) )
            .map((nestedArray : any[]) => nestedArray.map( value => value[propertyId]))
            .map((propertyIds : any[]) => propertyIds.filter((id, index , array) => array.indexOf(id) === index))
            .map((ids : any[]) => ids.map( (id : any) => {
                    if (id) {
                        return apiService.findById(id);
                    }
                    return Observable.of(null);
                })
            ).mergeAll();

        return pArr$.combineAll();
    }

}